module.exports = "/next-static/_next/static/images/block_image_invite_guests-364fd38a3c75aa6d02a920eb47ca9117.png";